module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/portal_key_v-80b115cb982dd930db38899a18494db1.jpg";